export const INLINE_IMAGE_CUSTOM_DATA_TEMPLATE = '{id}';
export const INLINE_IMAGE_URL_TEMPLATE =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAIBTAA7';
export const INLINE_IMAGE_ATTRIBUTE_DATA_CUSTOM = 'data-custom';
export const INLINE_IMAGE_ATTRIBUTE_ORIGINAL_SRC = 'originalsrc';
export const INLINE_IMAGE_ATTRIBUTE_LOAD_STATUS = 'data-loadstatus';
export const INLINE_IMAGE_ATTRIBUTE_VALUE_PENDING = 'pending';
export const INLINE_IMAGE_ATTRIBUTE_SRC = 'src';

export const INLINE_IMAGE_HANDLER_SELECTOR = `img[${INLINE_IMAGE_ATTRIBUTE_DATA_CUSTOM}],img[${INLINE_IMAGE_ATTRIBUTE_ORIGINAL_SRC}]`;
